import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';

export class CollectionOrdersContainerInput {
  id: number;
  collectionOrderId: number;
  containertypeId: number;
  containersQty: number;
  // containerType: {
  //   id: number;
  //   name: string;
  // };
  constructor() {
    // Initialize properties so Object.keys() can detect them
    this.id = undefined;
    this.collectionOrderId = undefined;
    this.containertypeId = undefined;
    this.containersQty = undefined;
  }
}

export class CollectionOrderXrbFileInput {
  id: number;
  collectionOrderXrbId: number;
  fieldName: string;
  fileId: number;
  sortOrder: number;
  notes: string;
}

/** Extension table (1:1) for ReBattery Li-ion collection order extras */
export class CollectionOrderXrbInput {
  id: number;
  collectionOrderId: number;
  msdsFileId: number;
  bmsFileId: number;
  techSpecFileId: number;
  manufacturer: string;
  partCode: string;
  chemistry: string;
  cellGeometry: string;
  nominalCapacity: string;
  nominalVoltage: string;
  nominalEnergyEfficiency: string;
  batteryWeight: number;
  pieceCount: number;
  batteryHeight: number;
  batteryLength: number;
  batteryWidth: number;
  replacementPackagingIsUsed: boolean;
  cablesSecured: boolean;
  safetyPlugInstalled: boolean;
  certifiedPackagingCode: string;
  packagingCondition: string;
  packagingHeight: number;
  packagingLength: number;
  packagingWidth: number;
  packagingReturnRequired: boolean;
  packagingDispatchDate: Date;
  packagingInstructions: string;
  temperatureReadingRequired: boolean;
  voltageReadingRequired: boolean;
  packagingTypeCode: string;
  collordPackagingReturnRequired: boolean;
  wastereceptionpointId: number;
  bmsCharacterization: string;
  bmsCharacterizationOther: string;
  technicianAssessment: string;
  technicianVerifiesData: boolean;
  technicianName: string;
  technicianRegistrationNumber: string;
  packagingForCriticallyDamaged: boolean;
  carAccident: boolean;
  fire: boolean;
  naturalDisasters: boolean;
  vandalism: boolean;
  batteryLiquidCoolingSystemFailure: boolean;
  noBmsData: boolean;
  fireSmokeSignsSigns: boolean;
  oxidationSigns: boolean;
  leakageVentingSigns: boolean;
  cannotDiagnose: boolean;
  safetyDeviceTriggered: boolean;
  additionalObservations: string;
  easyLoadingAccess: boolean;
  specialEquipmentRequired: boolean;
  collectionPointHasEquipment: boolean;
  equipmentDescription: string;
  otherAccessNotes: string;
  fileDetails: CollectionOrderXrbFileInput[];
  batteryCondition: string;
  appropriatePackaging: boolean;
  requiredPackaging: string;
  vermiculiteUsed: boolean;
  vermiculiteQuantity: string;
  aeroplastUsed: boolean;
  aeroplastQuantity: string;
  plasticBagUsed: boolean;
  plasticBagQuantity: string;
  polyethyleneUsed: boolean;
  polyethyleneQuantity: string;
  otherMaterial: string;
  totalRequestWeight: number;

  orgChemistry: string;
  orgBatteryWeight: number;
  orgPieceCount: number;
  orgBatteryHeight: number;
  orgBatteryLength: number;
  orgBatteryWidth: number;

  aiFileDataExtraction: string;
  aiIsAppropriatePackaging: boolean;
  aiIsAppropriatePackagingReasoning: string;
  aiPackagingMaterialsCalculations: string;

  constructor() {
    this.id = undefined;
    this.collectionOrderId = undefined;
    this.msdsFileId = undefined;
    this.bmsFileId = undefined;
    this.techSpecFileId = undefined;
    this.manufacturer = undefined;
    this.partCode = undefined;
    this.chemistry = undefined;
    this.cellGeometry = undefined;
    this.nominalCapacity = undefined;
    this.nominalVoltage = undefined;
    this.nominalEnergyEfficiency = undefined;
    this.batteryWeight = undefined;
    this.pieceCount = undefined;
    this.batteryHeight = undefined;
    this.batteryLength = undefined;
    this.batteryWidth = undefined;

    this.replacementPackagingIsUsed = undefined;
    this.cablesSecured = undefined;
    this.safetyPlugInstalled = undefined;

    this.certifiedPackagingCode = undefined;
    this.packagingCondition = undefined;
    this.packagingHeight = undefined;
    this.packagingLength = undefined;
    this.packagingWidth = undefined;
    this.packagingReturnRequired = undefined;
    this.packagingDispatchDate = undefined;
    this.packagingInstructions = undefined;
    this.temperatureReadingRequired = undefined;
    this.voltageReadingRequired = undefined;
    this.packagingTypeCode = undefined;
    this.collordPackagingReturnRequired = undefined;
    this.wastereceptionpointId = undefined;
    this.bmsCharacterization = undefined;
    this.bmsCharacterizationOther = undefined;
    this.technicianAssessment = undefined;
    this.packagingForCriticallyDamaged = undefined;
    this.carAccident = undefined;
    this.packagingCondition = undefined;
    this.packagingHeight = undefined;
    this.packagingLength = undefined;
    this.packagingWidth = undefined;
    this.packagingReturnRequired = undefined;
    this.bmsCharacterization = undefined;
    this.technicianAssessment = undefined;
    this.technicianVerifiesData = undefined;
    this.technicianName = undefined;
    this.technicianRegistrationNumber = undefined;
    this.carAccident = undefined;
    this.fire = undefined;
    this.naturalDisasters = undefined;
    this.vandalism = undefined;
    this.batteryLiquidCoolingSystemFailure = undefined;
    this.noBmsData = undefined;
    this.fireSmokeSignsSigns = undefined;
    this.oxidationSigns = undefined;
    this.leakageVentingSigns = undefined;
    this.cannotDiagnose = undefined;
    this.safetyDeviceTriggered = undefined;
    this.additionalObservations = undefined;
    this.easyLoadingAccess = undefined;
    this.specialEquipmentRequired = undefined;
    this.fireSmokeSignsSigns = undefined;
    this.oxidationSigns = undefined;
    this.leakageVentingSigns = undefined;
    this.cannotDiagnose = undefined;
    this.safetyDeviceTriggered = undefined;
    this.additionalObservations = undefined;
    this.easyLoadingAccess = undefined;
    this.specialEquipmentRequired = undefined;
    this.collectionPointHasEquipment = undefined;
    this.equipmentDescription = undefined;
    this.otherAccessNotes = undefined;
    this.specialEquipmentRequired = undefined;
    this.collectionPointHasEquipment = undefined;
    this.equipmentDescription = undefined;
    this.otherAccessNotes = undefined;
    this.fileDetails = undefined;
    this.batteryCondition = undefined;
    this.appropriatePackaging = undefined;
    this.requiredPackaging = undefined;
    this.vermiculiteUsed = undefined;
    this.vermiculiteQuantity = undefined;
    this.aeroplastUsed = undefined;
    this.aeroplastQuantity = undefined;
    this.plasticBagUsed = undefined;
    this.plasticBagQuantity = undefined;
    this.polyethyleneUsed = undefined;
    this.polyethyleneQuantity = undefined;
    this.otherMaterial = undefined;
    this.totalRequestWeight = undefined;

    this.orgChemistry = undefined;
    this.orgBatteryWeight = undefined;
    this.orgPieceCount = undefined;
    this.orgBatteryHeight = undefined;
    this.orgBatteryLength = undefined;
    this.orgBatteryWidth = undefined;

    this.aiFileDataExtraction = undefined;
    this.aiIsAppropriatePackaging = undefined;
    this.aiIsAppropriatePackagingReasoning = undefined;
    this.aiPackagingMaterialsCalculations = undefined;
  }
}
export class CollectionLineInput {
  id: number;
  aa: number;
  materialId: number;
  qty: number;
  netWeight: number;
  finDispNote: string;
  jobtypeId: number;

  constructor() {
    // Initialize properties so Object.keys() can detect them
    this.id = undefined;
    this.aa = undefined;
    this.materialId = undefined;
    this.qty = undefined;
    this.netWeight = undefined;
    this.finDispNote = undefined;
    this.jobtypeId = undefined;
  }
}
export class FormInput {
  actionId: number; // Re Battery Liion specific field > HistoryStates
  id: number;
  statusId: number;
  code: string;
  seriesId: number;
  codePrefix: string;
  codeNumber: number;
  orderedDate: Date;
  plannedCollectionDate: Date;
  collectionPointId: number;
  originatedFromId: number;
  recordedById: number;
  collectorId: number;
  isUrgent: boolean;
  userString1: string;
  userString2: string;
  userDate1: Date;
  legacyAppId: string;
  recordDate: Date;
  isActive: boolean;
  firstDate: Date;
  lastDate: Date;
  firstUser: string;
  lastUser: string;
  contactPerson: string;
  notes: string;
  /** Αριθμός Δελτίου Αποστολής (δήλωση οδηγού) */
  finDispNote: string;
  // collectionpoint: Collectionpoint
  // collector: Collector
  collectionOrdersContainers: [CollectionOrdersContainerInput];
  xrbData: CollectionOrderXrbInput;

  constructor() {
    this.actionId = undefined; // Re Battery Liion specific field > HistoryStates
    this.id = undefined;
    this.statusId = undefined;
    this.code = undefined;
    this.seriesId = undefined;
    this.codePrefix = undefined;
    this.codeNumber = undefined;
    this.orderedDate = undefined;
    this.plannedCollectionDate = undefined;
    this.collectionPointId = undefined;
    this.originatedFromId = undefined;
    this.recordedById = undefined;
    this.collectorId = undefined;
    this.isUrgent = undefined;
    this.userString1 = undefined;
    this.userString2 = undefined;
    this.userDate1 = undefined;
    this.legacyAppId = undefined;
    this.recordDate = undefined;
    this.isActive = undefined;
    this.firstDate = undefined;
    this.lastDate = undefined;
    this.firstUser = undefined;
    this.lastUser = undefined;
    this.contactPerson = undefined;
    this.notes = undefined;
    this.finDispNote = undefined;
    this.collectionOrdersContainers = undefined;
    this.xrbData = undefined;
  }
}

export const gqlGetQuery = gql`
  query getCollectionOrders($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectionOrders(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        statusId
        code
        seriesId
        codePrefix
        codeNumber
        orderedDate
        plannedCollectionDate
        collectionPointId
        collectorId
        legacyAppId
        recordDate
        isActive
        firstDate
        originatedFromId
        recordedById
        lastDate
        firstUser
        lastUser
        contactPerson
        notes
        finDispNote
        isUrgent
        userString1
        userString2
        userDate1
        collectionpoint {
          id
          name
          addressLine1
          addressArea
          addressCity
          addressDistrict
          phone
        }
        collector {
          id
          name
        }
        collectionOrdersContainers {
          id
          containertypeId
          containersQty
          containertype {
            id
            name
          }
        }
        collectionOrderState {
          id
          value
          name
        }
        routesLines {
          id
          aa
          route {
            id
            code
            routeDate
          }
        }
        collectionId
        collection {
          id
          code
          dateCollected
          idocs {
            id
            identificationDocument
            dateCollected
          }
        }
      }
      recordCount
    }
  }
`;
export const gqlGetCollectionPointById = gql`
  query getCollectionpointById($id: Int) {
    getCollectionpointById(id: $id) {
      id
      name
      companyVat
      companyTaxOffice
      gemiNumber
      imaCode
      addressLine1
      addressLine2
      addressArea
      addressCity
      addressNomos
      code
      notes
      addressDistrict
      latitude
      longitude
      customField1
      postalCode
      phone
      mobile
      fax
      email
      contributorName
      contactPerson
      groupId
      subgroupId
      subsubgroupId
      isPubliclyVisibleInMap
      recordDate
      legacyAppId
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      regionId
      region {
        id
        name
      }
      professionId
      profession {
        id
        name
      }
      parentCpId
      parentCollectionpoint {
        id
        name
      }
    }
  }
`;
export const gqlGetByIdQuery = gql`
  query getCollectionOrderById($id: Int) {
    getCollectionOrderById(id: $id) {
      id
      statusId
      code
      seriesId
      codePrefix
      codeNumber
      orderedDate
      plannedCollectionDate
      collectionPointId
      collectorId
      legacyAppId
      recordDate
      originatedFromId
      recordedById
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      contactPerson
      notes
      finDispNote
      isUrgent
      userString1
      userString2
      userDate1
      collectionpoint {
        id
        name
        addressLine1
        addressArea
        addressCity
        postalCode
        phone
        email
        contributorName
      }
      # collector
      collectionOrdersContainers {
        id
        containertypeId
        containersQty
        containertype {
          id
          name
        }
      }
      collectionOrderState {
        id
        value
        name
      }
      routesLines {
        id
        aa
        route {
          id
          code
          routeDate
        }
      }
      collectionId
      collection {
        id
        code
        dateCollected
        idocs {
          id
          identificationDocument
        }
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addCollectionOrder($data: CollectionOrderInput) {
    addCollectionOrder(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateCollectionOrder($data: CollectionOrderInput) {
    updateCollectionOrder(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteCollectionOrder($id: Int) {
    deleteCollectionOrder(id: $id)
  }
`;
export const gqlDeleteCollectionLine = gql`
  mutation deleteCollectionLine($id: Int) {
    deleteCollectionLine(id: $id)
  }
`;

export const gqlDeleteCollectionOrderContainer = gql`
  mutation deleteCollectionOrdersContainer($id: Int) {
    deleteCollectionOrdersContainer(id: $id)
  }
`;

export async function getWasteReceptionPointById(
  client: ApolloClient<object>,
  id: number,
): Promise<any> {
  const gqlScript = gql`
    query getWastereceptionpointById($id: Int) {
      getWastereceptionpointById(id: $id) {
        id
        name
        phone
        email
        companyVat
        companyTaxOffice
        addressLine1
        addressLine2
        addressCity
        addressArea
        postalCode
        regionId
        subregionId
        receptionPersonName
      }
    }
  `;
  const ret = await client.query({
    query: gqlScript,
    variables: { id },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getWastereceptionpointById;
}

export async function getDriverByUserId(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getQuery($where: String) {
      getDrivers(where: $where) {
        data {
          id
          name
          userId
          adrNumber
          user {
            id
            fullName
            signatureFileId
          }
        }
      }
    }
  `;
  const where = {
    userId: id,
  };
  const ret = await client.query({
    query: gqlScript,
    variables: { where: JSON.stringify(where) },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getDrivers?.data[0];
}

export async function getDriverById(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getDriverById($id: Int) {
      getDriverById(id: $id) {
        id
        name
        userId
        adrNumber
        user {
          id
          fullName
          signatureFileId
        }
      }
    }
  `;
  return new Promise((resolve, reject) => {
    client
      .query<any, { id: number }>({
        query: gqlScript,
        variables: { id },
      })
      .then((res) => {
        if (res.data[Object.keys(res.data)[0]] !== null) {
          resolve(res.data[Object.keys(res.data)[0]]);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}

export async function getVehicleById(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getVehicleById($id: Int) {
      getVehicleById(id: $id) {
        id
        plateNumber
      }
    }
  `;
  return new Promise((resolve, reject) => {
    client
      .query<any, { id: number }>({
        query: gqlScript,
        variables: { id },
      })
      .then((res) => {
        if (res.data[Object.keys(res.data)[0]] !== null) {
          resolve(res.data[Object.keys(res.data)[0]]);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}

export async function getIdocwastetypeById(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getQuery($id: Int) {
      getIdocwastetypeById(id: $id) {
        id
        wasteTypeName
        defEkaCode
        ekaCodeValues
        defUnClass
        unClassValues
      }
    }
  `;

  const ret = await client.query({
    query: gqlScript,
    variables: { id },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getIdocwastetypeById;
}

export function getCollectionpointById(client: ApolloClient<object>, id: number): Promise<any> {
  return new Promise((resolve, reject) => {
    client
      .query<any, { id: number }>({
        query: gql`
          query getCollectionpointById($id: Int) {
            getCollectionpointById(id: $id) {
              id
              name
              phone
              email
              groupId
              subgroupId
              subsubgroupId
              companyVat
              companyTaxOffice
              addressLine1
              addressLine2
              addressCity
              addressArea
              postalCode
              regionId
              contactPerson
            }
          }
        `,
        variables: { id },
      })
      .then((res) => {
        if (res.data.getCollectionpointById !== null) {
          resolve(res.data.getCollectionpointById);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}

export async function getWasteReceptionPoint(
  client: ApolloClient<object>,
  where: any,
): Promise<any> {
  const gqlScript = gql`
    query getWastereceptionpoints($where: String) {
      getWastereceptionpoints(where: $where) {
        data {
          id
          name
          isActive
          addressLine1
          phone
          companyVat
          companyTaxOffice
          receptionPersonName
        }
        recordCount
      }
    }
  `;
  const ret = await client.query({
    query: gqlScript,
    variables: { where: JSON.stringify(where) },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getWastereceptionpoints;
}

export async function getContainertypes(client: ApolloClient<object>, where: any): Promise<any> {
  const gqlScript = gql`
    query getContainertypes($limit: Int, $offset: Int, $order: String, $where: String) {
      getContainertypes(limit: $limit, offset: $offset, order: $order, where: $where) {
        data {
          id
          name
        }
        recordCount
      }
    }
  `;
  const ret = await client.query({
    query: gqlScript,
    variables: { where: JSON.stringify(where) },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getContainertypes;
}

export async function getCollectorById(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getCollectorById($id: Int) {
      getCollectorById(id: $id) {
        id
        name
        companyVat
        companyTaxOffice
        imaCode
        contractNo
        contractSignDate
        contractExpDate
        formalName
        addressLine1
        addressLine2
        addressArea
        addressCity
        postalCode
        phone
        mobile
        fax
        email
        email2
        contactperson
        notes
      }
    }
  `;

  return new Promise((resolve, reject) => {
    client
      .query<any, { id: number }>({
        query: gqlScript,
        variables: { id },
      })
      .then((res) => {
        if (res.data[Object.keys(res.data)[0]] !== null) {
          resolve(res.data[Object.keys(res.data)[0]]);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}
